<script>
    export default {
        name: "AuthCallback",
        async beforeMount() {
            await this.$auth.handleAuthentication();
            this.$router.replace({
                path: this.$store.getters["loginRedirect"]
            });
        },
        render() {}
    };
</script>



// WEBPACK FOOTER //
// src/components/AuthCallback.vue